import type {Optional} from '@yandex-delivery/types'
import {get, isNotUndefined} from '@yandex-delivery/utils'

import type {FormGroupedVerticals, FormOrderResponse} from 'src/shared/types'

import {toTariffVerticals} from './to-tariff-verticals'

export function mapVerticalsToGroups(response: Optional<FormOrderResponse>) {
  const verticals = toTariffVerticals(response)
  const verticalGroups = get('vertical_groups', response)

  return verticalGroups?.reduce<FormGroupedVerticals>((acc, group) => {
    const title = get('title', group)
    const groupVerticals = get('verticals', group)

    if (title === undefined) {
      return acc
    }

    acc[title] = groupVerticals
      ?.map(verticalId => verticals?.find(vertical => vertical.id === verticalId))
      .filter(isNotUndefined)

    return acc
  }, {})
}
